import React from 'react'
import { compose } from 'recompose'
import { translate } from 'react-i18next'
import 'moment/locale/fr'
import 'moment/locale/nl'
import * as translationService from './../../services/translationService'
import * as networkService from './../../services/networkService'
import { getFullAddressForProperty, getBrokerForProperty } from './../../utils/property'

import { Spinner, ResourceList, ErrorText, EmptyState } from './../../components'
import { dump } from '../../services/debugService'
import { Application } from './components/Application'

export const HistoryView = () => {
  const [isLoading, setLoading] = React.useState(true)
  const [applications, setApplications] = React.useState([])
  const [error, setError] = React.useState()

  React.useEffect(() => {
    fetchApplications()
  }, [])

  const fetchApplications = async () => {
    try {
      const applicattionData = await networkService.getApplications()
      const applications = applicattionData.data.filter(application => !!application.property).map(application => ({
        ...application,
        date: application.providedAt,
        propertyAddress: getFullAddressForProperty(application.property),
        propertyId: application.property.id,
        price: application.property.price.toString(),
        broker: getBrokerForProperty(application),
      }))
      setLoading(false)
      setApplications(applications)
    } catch (err) {
      dump(err)
    }
  }

  const removeFromBroker = async applicationId => {
    resetError()
    try {
      await networkService.removeApplicationAtBroker(applicationId)
      fetchApplications()
    } catch (error) {
      const errorObj = error.response && error.response.data && error.response.data.error
      setError(errorObj)
    }
  }

  const resetError = () => {
    setError()
  }

  return (
    <React.Fragment>
      {error && <ErrorText>{error.message}</ErrorText>}
      {isLoading && <Spinner />}
      {!isLoading &&
        (applications.length ? (
          <ResourceList
            items={applications}
            renderItem={item => <Application application={item} removeFromBroker={removeFromBroker} />}
          />
        ) : (
          <EmptyState heading={translationService.mySubmissionHistoryEmptyTitle()}>
            <p>{translationService.mySubmissionHistoryEmptyText()}</p>
          </EmptyState>
        ))}
    </React.Fragment>
  )
}
export default compose(translate('translations'))(HistoryView)



// WEBPACK FOOTER //
// ./src/views/Profile/History.js